import type { FaireProductEntity } from "../../entity_types/product";

export const p_rvmzmqcxnm: FaireProductEntity = {
  token: "p_rvmzmqcxnm",
  type: "product",
  name: "Jar Sprouts Growing Kit",
  brandToken: "b_mqd3fq3zm9",
  brandName: "ZestiGreens",
  imageUrl:
    "https://cdn.faire.com/fastly/4a13171892a49087551f23870add86d45e2403262d16d9738e37949dc7586cb4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b8b5749b72f28fdea085aaa26ad129ec1cda85c4302f7a9916cfdcd9d534b5c9.jpeg",
    "https://cdn.faire.com/fastly/a67bafacc85b918a889f0d5c2c030cf95fca59873079d6a1f6da73674dd8f4a2.jpeg",
    "https://cdn.faire.com/fastly/19b1231800037066669ddca329e0e49929514211f9091c8ec2ff5cccaa318c8d.jpeg",
    "https://cdn.faire.com/fastly/579f8b1922ae0ca34f240897bd5123849b88b2939788c19300d09da214dc2733.jpeg",
    "https://cdn.faire.com/fastly/6e0453d8095e7c0dd1c44ec931e0a60ca44ed56d41c4a06ac3ad2b991f3958e8.jpeg",
    "https://cdn.faire.com/fastly/3227c65e0293dd98d2fda9807a697caf1b7e75153918ee7df98e37cd5492df27.jpeg",
  ],
  priceDollars: 13.97,
  description:
    "Grow fresh, crunchy sprouts right in your kitchen!\nThe ZestiGreens Sprouting Kit makes it easy and fun to grow your own healthy greens year-round — perfect for salads, sandwiches, and smoothies. This complete 12-piece set includes two 32oz glass jars, sprouting lids, a green onion regrower lid, stainless steel stand, drip tray, blackout sleeves, and illustrated instructions (seeds not included). Grow a variety of sprouts like broccoli, alfalfa, radish, and mung beans — or regrow your own green onions hydroponically! Ideal for beginners and a thoughtful gift for anyone who loves fresh, homegrown nutrition.\n",
  tags: [],
  msrpDollars: 27.95,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:25.500Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
